import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const ExceptionPage = () => {

    const location = useLocation();
    const navigate = useNavigate();
 
    const queryParams = new URLSearchParams(location.search);
    const errorMessage = queryParams.get("message") || "An unexpected error occurred.";
    const redirectPage = "/"+ queryParams.get("page") || "/loan";
     
    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-6">
            <div className="bg-white shadow-lg rounded-lg p-6 w-full max-w-md text-center">
                <h2 className="text-red-600 text-xl font-bold">Error</h2>
                <p className="text-gray-700 mt-2">{errorMessage}</p>
                    <button
                            onClick={() => navigate(redirectPage)}
                            className="mt-4 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition"
                    >
                        Refresh
                    </button>
            </div>
        </div>

    );

};
 
export default ExceptionPage;
